import { getCookie } from "cookies-next";
import { LANG } from "./common";

export const APP_ROUTES = (lang?: "en" | "vi" | "id" | string) => {
  const locale = lang || getCookie(LANG) || "en";
  return {
    HOME: {
      to: `/${locale}/report`,
      title: "Report",
      DETAIL: {
        to: (slug: string, mode: string) =>
          `/${locale}/report/${slug}?mode=${mode}`,
        MODE: {
          POWERBI: {
            to: (slug: string) => `/${locale}/report/${slug}?mode=powerbi`,
            title: "Report Interactive",
          },
          PDF: {
            to: (slug: string) => `/${locale}/report/${slug}?mode=pdf`,
            title: "Report PDF",
          },
          EMBED: {
            to: (slug: string) => `/${locale}/report/${slug}?mode=embed`,
            title: "Report Embedded",
          },
        },
      },
    },
    BLOG_DETAIL: {
      to: (slug: string) => `/${locale}/blog/${slug}`,
      title: "Blog Detail",
    },
    RESOURCES: {
      title: "Resources",
      ROOT: `/${locale}/category`,
      to: (slug: string) => `/${locale}/category/${slug}`,
    },
    VERIFIED_OTP_INDENTITY: {
      to: "/identity-verification",
      title: "verification otp",
    },
    WARNNING_DOWNLOAD: {
      to: "/warnning-download",
      title: "Warnning Download",
    },
    TRIAL: {
      to: `/${locale}/trial`,
      title: "Trial",
      ROOT: `/${locale}/trial`,
      ACTIVE: {
        to: `/${locale}/trial/:id/active`,
        title: "Active Trial",
        ROOT: `/${locale}/trial/:id/active`,
      },
    },
    ACCOUNT: {
      to: `/${locale}/account`,
      title: "Account",
      ROOT: `/${locale}/account`,
      PROFILE: { to: `/${locale}/account/profile`, title: "Profile" },
      SUBSCRIPTION: {
        to: `/${locale}/account/subscription`,
        title: "Subscription",
      },
      BILLING_HISTORY: {
        to: `/${locale}/account/billing-history`,
        title: "Billing History",
      },
      ORGANISATION: {
        to: `/${locale}/account/organisation`,
        title: "Organisation",
      },
      PASSWORD_SECURITY: {
        to: `/${locale}/account/password-security`,
        title: "Password & Security",
      },
      LANGUAGE: { to: `/${locale}/account/language`, title: "Language" },
    },
    LOGIN: {
      to: `/${locale}/login`,
      title: "Login",
    },
    VERIFIED_OTP: {
      to: `/${locale}/verify-otp`,
      title: "Verify OTP",
    },
    REGISTER: {
      to: `/${locale}/register`,
      title: "Register",
    },
    //  REGISTER2: {
    //   to: "/register2",
    //   title: "Register2",
    // },
    FORGOTPASSWORD: {
      to: `/${locale}/forgot-password`,
      title: "Forgot password",
    },
    PRICING: {
      to: `/${locale}/pricing`,
      title: "Pricing",
    },
    FAQ: {
      to: `/${locale}/faq`,
      title: "FAQ",
    },
    PURCHASED_REPORTS: {
      to: `/${locale}/purchased-reports`,
      title: "Purchased Reports",
    },
    SAVED_DASHBOARD: {
      to: `/${locale}/saved-dashboards`,
      title: "Saved Dashboards",
    },
    RESULT: {
      to: `/${locale}/result`,
      title: "FAQ",
    },
    FAVORITE: {
      to: `/${locale}/favorite`,
      title: "Favorite",
    },
    UPCOMING: {
      to: `/${locale}/upcoming`,
      title: "UPCOMING",
      FAVORITE: {
        to: `/${locale}/upcoming/favorite`,
      },
    },

    CALLBACK: {
      REPORT: {
        to: "/callback/report",
        title: "CALLBACK",
      },
      REPORT_AGAIN: {
        to: "/cb/report/:id/onepay",
        title: "CALLBACK",
      },
      SUBSCRIPTION: {
        to: "/callback/subscription/plan",
        title: "CALLBACK",
      },
      SUBSCRIPTION_AGAIN: {
        to: "/cb/subscription/:id/onepay",
        title: "CALLBACK",
      },
      REPORT_MULTIPLE_SUBSCRIPTION: {
        to: "/callback/multiple-subscription",
        title: "CALLBACK",
      },
      REPORT_MULTIPLE_SUBSCRIPTION_AGAIN: {
        to: "/cb/multiple-subscription/onepay",
        title: "CALLBACK",
      },
    },
    PAYMENT: {
      REPORT: {
        ROOT: {
          to: `/${locale}/payment/:id/preview?module=report`,
          title: "Payment",
        },
        COMPLETED: {
          to: `/${locale}/payment/:id/preview/purchase-success?module=report&order=:order`,
          title: "Payment - completed",
        },
        ONPAYFAIL: {
          to: `/${locale}/payment/:id/preview/purchase-failed?module=report&order=:order`,
          title: "Payment - failded",
        },
        ONPAYPENDING: {
          to: "",
          title: "",
        },
      },
      SUBSCRIPTION: {
        ROOT: {
          to: `/${locale}/payment/:id/preview?module=plan`,
          title: "Payment",
        },
        RENEW: {
          to: `/${locale}/payment/:id/preview?module=plan&action=renew`,
          title: "Payment - renew",
        },
        UPGRADE: {
          to: `/${locale}/payment/:id/preview?module=plan&action=upgrade`,
          title: "Payment - upgrade",
        },
        COMPLETED: {
          to: `/${locale}/payment/:id/preview/purchase-success?module=plan`,
          title: "Payment - completed",
        },
        COMPLETED_MULTI: {
          to: `/${locale}/payment/:id/preview/purchase-success?module=plan&type=org`,
          title: "Payment - completed - org",
        },
        ONPAYFAIL: {
          to: `/${locale}/payment/:id/preview/purchase-failed?module=plan`,
          title: "Payment - failded",
        },
        ONPAYFAIL_MULTIPLE: {
          to: `/${locale}/payment/:id/preview/purchase-failed?module=plan&type=org`,
          title: "Payment - failded - org",
        },
      },
      SUBSCRIPTIONS: {
        ROOT: {
          to: `/${locale}/payment-multiple-subscription`,
          title: "Payment",
        },
      },
    },
    TERMS_AND_SERVICE: {
      to: `/${locale}/terms-and-service`,
      title: "Terms and Service",
    },
    RESET_PASSWORD: {
      to: `/${locale}/reset-password/:code`,
      title: "Reset password",
    },

    INVALID_RESET_PASSWORD: {
      to: `/${locale}/invalid-reset-password`,
      title: "Invalid reset password",
    },

    SHARED: {
      to: (token: string) => `/${locale}/shared/${token}`,
      title: "Shared Report",
    },
  };
};
